import Cookies from 'js-cookie'

const SELECTED_BUILDING = 'SELECTED_BUILDING'
const AUTH_USER_DATA = 'AUTH_USER_DATA'
const SELECTED_CLASSROOM = 'SELECTED_CLASSROOM'

const expires = { expires: 7 }

export const getUserData = () => {
  const { id, name, email, functionalities } = Cookies.getJSON(AUTH_USER_DATA) || {}
  return { id, name, email, functionalities }
}

export const setSelectedBuilding = (building) => {
  Cookies.set(SELECTED_BUILDING, building, expires)
}

export const getSelectedBuilding = () => {
  return Cookies.getJSON(SELECTED_BUILDING)
}

export const removeSelectedBuilding = () => {
  Cookies.remove(SELECTED_BUILDING)
}

export const setSelectedClassroom = (classroom) => {
  return Cookies.set(SELECTED_CLASSROOM, classroom, expires)
}

export const getSelectedClassroom = () => {
  return Cookies.getJSON(SELECTED_CLASSROOM)
}

export const removeSelectedClassroom = () => {
  Cookies.remove(SELECTED_CLASSROOM)
}
